import { PERMISSION } from "@app/modules/roles/constants";
import { COUNTRY_CODE } from "@environments/environment.type";

interface VerticalMenuBasic {
  icon: string;
  text: string;
  link: string;
  unavailableRegions?: COUNTRY_CODE[];
  highlight?: boolean;
  permission?: PERMISSION;
  permissions?: PERMISSION[];
  disabledWhen?: string[];
  cashlessOnly?: boolean;
  requiresZappieAccess?: boolean;
  /** Reemplaza el texto traducido del ítem por una imagen (ej. el wordmark de Propio). */
  textImage?: string;
  /** Marca pequeña en línea junto al texto de una subsección (ej. el isotipo b&w de Propio). */
  subMark?: string;
}
interface VerticalMenuNested {
  icon: string;
  text: string;
  unavailableRegions?: COUNTRY_CODE[];
  subsections: Omit<VerticalMenuBasic, "icon">[];
  permission?: PERMISSION;
  permissions?: PERMISSION[];
  cashlessOnly?: boolean;
}

export type VerticalMenuItem = VerticalMenuBasic | VerticalMenuNested;

export const DISMISSED_HEADER_LS_KEY = "dismissed-header-announcement-";
export const DISMISSED_NOTIFICATION_LS_KEY = "dismissed-notification-announcement-";
export const DISMISSED_BANNER_LS_KEY = "dismissed-banner-announcement-";

export const DISABLED_WHEN_NO_PP = "no-pp";
export const DISABLED_WHEN_NO_ORDERS = "no-orders";
